import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Welcome_Video.css";

const Welcome_Video = () => {
  const navigate = useNavigate();

  // Auto redirect after video duration
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/home");
    }, 7000); // match video duration (ms)

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="splash_screen">
      <video className="splash_video" autoPlay muted playsInline>
        <source src="/Assets/video/login-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default Welcome_Video;
